export const StatCard = ({ title, value, icon: Icon, trend, subtitle, color = "blue" }) => {
  const colorClasses = {
    blue: "from-blue-500/20 to-blue-600/10 border-blue-500/30",
    green: "from-emerald-500/20 to-emerald-600/10 border-emerald-500/30",
    red: "from-red-500/20 to-red-600/10 border-red-500/30",
    orange: "from-orange-500/20 to-orange-600/10 border-orange-500/30",
    purple: "from-purple-500/20 to-purple-600/10 border-purple-500/30",
  };

  return (
    <div 
      data-testid={`stat-card-${title.toLowerCase().replace(/\s/g, '-')}`}
      className={`bg-gradient-to-br ${colorClasses[color]} border rounded-xl p-5 backdrop-blur-sm`}
    >
      <div className="flex items-center justify-between mb-3">
        <span className="text-gray-400 text-sm font-medium">{title}</span>
        <Icon className="w-5 h-5 text-gray-500" />
      </div>
      <div className="flex items-end gap-2">
        <span className={`text-2xl font-bold ${trend === 'up' ? 'text-emerald-400' : trend === 'down' ? 'text-red-400' : 'text-white'}`}>
          {value}
        </span>
        {subtitle && <span className="text-gray-500 text-sm mb-1">{subtitle}</span>}
      </div>
    </div>
  );
};
